import React from "react";

export default function Footer() {
  return (
    <>
      <footer className="relative bg-slate-950 pt-12 pb-8 text-white">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon className="text-brandButton fill-current" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-3xl font-semibold text-white">Payron Global</h4>
              <h5 className="mt-3 text-lg text-slate-300">
              Ethiopia and Dubai based creative support for brands that want a premium international presence.
              </h5>
              <div className="mt-6 mb-6 lg:mb-0">

              
              <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
                      <li className="flex items-center">
                        <a
                          className="hover:text-brandAccent text-brandHeadline px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                          href="https://www.facebook.com/people/Birhan-Aschalew/pfbid02djV5DMAcXJzJtLzw3pTATs959tWmfijuuaXcLHKVqgj9ZffpKSe9c7Qb3L3orF8sl/?mibextid=ZbWKwL"
                          target="_blank" rel="noopener noreferrer"
                        >
                          <i className="text-slate-400 fab fa-facebook text-lg leading-lg  " />
                          <span className="lg:hidden inline-block ml-2">
                            Share
                          </span>
                        </a>
                      </li>

                      <li className="flex items-center">
                        <a
                          className="hover:text-brandAccent text-brandHeadline px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                          href="https://twitter.com/"
                          target="_blank" rel="noopener noreferrer"
                        >
                          <i className="text-slate-400 fab fa-twitter text-lg leading-lg " />
                          <span className="lg:hidden inline-block ml-2">
                            Tweet
                          </span>
                        </a>
                      </li>


                      <li className="flex items-center">
                        <a
                          className="hover:text-brandAccent text-brandHeadline px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                          href="https://www.instagram.com/payronglobal/"
                          target="_blank" rel="noopener noreferrer"
                        >
                          <i className="text-slate-400 fab fa-instagram text-lg leading-lg " />
                          <span className="lg:hidden inline-block ml-2">
                            Post
                          </span>
                        </a>
                      </li>
                      <li className="flex items-center">
                        <a
                          className="hover:text-brandAccent text-brandHeadline px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                          href="https://www.linkedin.com/company/payronglobal/?viewAsMember=true"
                          target="_blank" rel="noopener noreferrer"
                        >
                          <i className="text-slate-400 fab fa-linkedin-in text-lg leading-lg " />
                          <span className="lg:hidden inline-block ml-2">
                            post
                          </span>
                        </a>
                      </li>
                    </ul>
                
                
              </div>
            
            
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-slate-400 text-sm font-semibold mb-2">
                 Locations
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-brandHeadline hover:text-brandAccent font-semibold block pb-2 text-sm"
                        href="https://www.linkedin.com/company/payron/"  role="button"  target="_blank" rel="noopener noreferrer"
                      >
                         Ethiopia
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-brandHeadline hover:text-brandAccent font-semibold block pb-2 text-sm"
                        href="https://www.linkedin.com/company/payron/" role="button" target="_blank" rel="noopener noreferrer"
                      >
                      Dubai
                      </a>
                    </li>
                    
                    <li>
                      <a
                        className="text-brandHeadline hover:text-brandAccent font-semibold block pb-2 text-sm"
                        href="https://www.linkedin.com/company/payron/" role="button" target="_blank" rel="noopener noreferrer"
                      >
              
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-slate-400 text-sm font-semibold mb-2">
                  Trust
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-brandHeadline hover:text-brandAccent font-semibold block pb-2 text-sm"
                        href="https://www.linkedin.com/company/payron/" role="button" target="_blank" rel="noopener noreferrer"
                      >
                      Refund Policy
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-brandHeadline hover:text-brandAccent font-semibold block pb-2 text-sm"
                        href="https://et.linkedin.com/in/birhan-aschalew-9a33a2232" role="button" target="_blank" rel="noopener noreferrer"
                      >
                        Testimonials
                      </a>
                    </li>
              
                    <li>
                      <a
                        className="text-brandHeadline hover:text-brandAccent font-semibold block pb-2 text-sm"
                        href="https://www.facebook.com/people/Birhan-Aschalew/pfbid02djV5DMAcXJzJtLzw3pTATs959tWmfijuuaXcLHKVqgj9ZffpKSe9c7Qb3L3orF8sl/?mibextid=ZbWKwL"
                        role="button" target="_blank" rel="noopener noreferrer" >
                        Payron Global
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-slate-800" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-slate-400 font-semibold py-1">
                Copyright © 2026 Payron Global. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
